import { badgeTemplatePreviewWidget } from './BadgeTemplatePreviewWidget';
import { customLayoutWidget } from './CustomLayoutWidget';
export const badgesCustomWidgets = [badgeTemplatePreviewWidget, customLayoutWidget];
